export const TOGGLE = 'list.infinite.check.toggle';
export const TOGGLE_ALL = 'list.infinite.check.toggleAll';
export const CHECKED_ALL = 'list.infinite.check.checkedAll';

/**
 * Toggle položky.
 * @param area oblast
 * @param id id položky
 */
export function toggle(area, id) {
    return {
        type: TOGGLE,
        area,
        id
    }
}

/**
 * Toggle all položek.
 * @param area oblast
 */
export function toggleAll(area) {
    return {
        type: TOGGLE_ALL,
        area
    }
}

/**
 * Zaškrtnout vše.
 * @param area oblast
 * @param checked zaškrtnout/odškrtnout
 */
export function checkedAll(area, checked = true) {
    return {
        type: CHECKED_ALL,
        checked,
        area
    }
}
